import { render } from "./ventilationController.vue?vue&type=template&id=4d9242ae&scoped=true"
import script from "./ventilationController.vue?vue&type=script&lang=js"
export * from "./ventilationController.vue?vue&type=script&lang=js"

import "./ventilationController.vue?vue&type=style&index=0&id=4d9242ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d9242ae"]])

export default __exports__